import React from 'react';
import { Typography, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ProfilesCWizard from './ProfilesCWizard';

const Profiles = () => {
  const { t } = useTranslation();
  return (
    <Container>
    <Typography variant="h5" gutterBottom>
        {t("Profiles.CreateProfile")}
    </Typography>

    <ProfilesCWizard/>
  </Container>
  );
};

export default Profiles;
